import { combineReducers } from "redux";

import { accountSettingsStore } from "./accountSettings";
import { chatStore } from "./chat";
import { notificationStore } from "./Notifications";
import { recentColleaguesStore } from "./recentColleagues";
import { session } from "./session";
import { shiftStore } from "./shift";
import { specialitiesStore } from "./specialities";

export const rootReducer = combineReducers({
  session,
  shiftStore,
  specialitiesStore,
  accountSettingsStore,
  notificationStore,
  chatStore,
  recentColleaguesStore,
});
